import { arcgisToGeoJSON } from "@esri/arcgis-to-geojson-utils";
import { get, writable } from "svelte/store";
import LoadState from "../../Enums/LoadState";
import GeoHelper from "../../Helpers/GeoHelper";
import VisibilityState from "../../Map/Enums/VisibilityState";
import { Paint } from "../../Map/MapLayerStyles";
import PopupStore from "../../Map/Popup/PopupStore";
import MapStore from "../../Map/Store";
import ESRIClassStore from "../../Stores/ESRIClassStore";
import MARMAN from "./MARMAN";

// TODO: this func is same in UKHOcharts store
const initLayerData = () => {
	return {
		layers: [],
		visible: writable(true)
	};
};
// TODO: This can be refactored, the same pattern is used by MaritimeBoundaries.
// Maritime Conservation and Management Zone
const MARMANsStore = {
	config: {
		server: "https://services1.arcgis.com/ZURaVO35aTK1Ugmq/arcgis/rest/services",
		marman: "/UKHO_MARMAN/FeatureServer"
	},
	meta: {
		loadState: writable(LoadState.INIT),
		layers: [],
		layerData: {
			esri_marman: initLayerData()
		},
		visible: writable(false),
		esri: {
			objects: {
				layers: {
					marman: null
				}
			}
		},
		lastUpdated: writable(0)
	},
	filters: {
		filterString: writable("")
	},
	results: {
		marmans: writable([])
	},
	spatialQuery: {
		meta: {
			loadState: writable(LoadState.INIT),
			error: writable("")
		},
		results: {
			marmans: writable([])
		}
	},
	actions: {
		init: () => {
			if (get(MARMANsStore.meta.loadState) !== LoadState.INIT) {
				return;
			}
			MARMANsStore.meta.loadState.set(LoadState.LOADING);
			// loadModules(["esri/Map", "esri/layers/FeatureLayer", "esri/identity/IdentityManager", "esri/tasks/support/Query", "esri/geometry/Point", "esri/geometry/SpatialReference"])
			ESRIClassStore.actions.load()
				.then((classes) => {
					const ESRIMap = ESRIClassStore.classes.Map.classPrototype;
					const FeatureLayer = ESRIClassStore.classes.FeatureLayer.classPrototype;
					const IdentityManager = ESRIClassStore.classes.IdentityManager.classPrototype;
					const Query = ESRIClassStore.classes.Query.classPrototype;
					const Point = ESRIClassStore.classes.Point.classPrototype;
					const SpatialReference = ESRIClassStore.classes.SpatialReference.classPrototype;
					const marmanUrl = MARMANsStore.config.server + MARMANsStore.config.marman;
					const marmanLayer = new FeatureLayer({ url: marmanUrl, layerId: 2 });
					MARMANsStore.meta.esri.objects.layers.marman = marmanLayer;

					const query = new Query();
					query.returnGeometry = false;
					query.where = "1 = 1";
					query.outFields = [
						"objnam",
						"nation",
						"catmma",
						"identy",
						"FID"
					];

					Promise.all([
						marmanLayer.queryFeatures(query)
					]).then((responses) => {
						const map = MapStore.helpers.getMap();

						const marmans = [];

						const marmanData = responses[0];
						for (let i = 0; i < marmanData.features.length; i++) {
							const feature = arcgisToGeoJSON(marmanData.features[i]);
							const marman = new MARMAN(feature);
							marmans.push(marman);
						}

						MARMANsStore.helpers._addDataLayer("esri_marman", "fill", Paint.eez, GeoHelper.emptyGeoJson());
						MARMANsStore.meta.layerData.esri_marman.layers.push("esri_marman");

						const onEnterPoint = (e) => {
							if (e.features.length > 0) {
								const props = {
									Name: e.features[0].properties.objnam,
									Category: e.features[0].properties.catmma
								};
								PopupStore.actions.custom(props, e.lngLat, true);
							}
						};
						const onLeavePoint = () => {
							PopupStore.actions.custom({}, null, false);
						};
						map.on("mouseenter", MARMANsStore.meta.layerData.esri_marman.layers[0], onEnterPoint);
						map.on("mouseleave", MARMANsStore.meta.layerData.esri_marman.layers[0], onLeavePoint);

						MARMANsStore.results.marmans.set(marmans);
						MARMANsStore.meta.loadState.set(LoadState.LOADED);

						MARMANsStore.meta.lastUpdated.set(Date.now());
					});
				});
		},
		spatialQuery: (lngLatArray) => {
			MARMANsStore.spatialQuery.meta.error.set("");
			MARMANsStore.spatialQuery.meta.loadState.set(LoadState.LOADING);

			const SpatialReference = ESRIClassStore.classes.SpatialReference.classPrototype;
			const Point = ESRIClassStore.classes.Point.classPrototype;
			const Query = ESRIClassStore.classes.Query.classPrototype;

			const point = new Point({
				longitude: lngLatArray[0],
				latitude: lngLatArray[1],
				spatialReference: SpatialReference.WebMercator// WGS84 // WebMercator
			});

			MARMANsStore.meta.esri.objects.layers.marman.createQuery();
			const query1 = new Query({
				returnGeometry: false,
				outFields: [
					"objnam",
					"nation",
					"catmma",
					"identy",
					"FID"
				],
				geometryPrecision: 3,
				spatialRelationship: "intersects",
				geometry: point,
				num: 5
			});

			const queries = [
				MARMANsStore.meta.esri.objects.layers.marman.queryFeatures(query1)
			];
			Promise.all(queries)
				.then((responses) => {
					const marmanResponse = responses[0];

					const allMarmanResultIds = marmanResponse.features.map((item) => {
						return item.attributes.FID;
					});
					const allMarmans = get(MARMANsStore.results.marmans);
					const filteredMarmans = allMarmans.filter((marman) => {
						return (// boundary.type === "EEZ" &&
							allMarmanResultIds.indexOf(marman.esriId) >= 0);
					});

					MARMANsStore.spatialQuery.results.marmans.set(filteredMarmans);
					MARMANsStore.spatialQuery.meta.loadState.set(LoadState.LOADED);
				})
				.catch((error) => {
					MARMANsStore.spatialQuery.meta.error.set(error.message);
					MARMANsStore.spatialQuery.meta.loadState.set(LoadState.INIT);
				});
		},
		updateVisibility: () => {
			const map = MapStore.helpers.getMap();
			if (map) {
				if (get(MARMANsStore.meta.loadState) !== LoadState.LOADED) {
					return;
				}
				const visible = get(MARMANsStore.meta.visible);
				const dataLayers = Object.keys(MARMANsStore.meta.layerData);
				for (let i = 0; i < dataLayers.length; i++) {
					const layer = MARMANsStore.meta.layerData[dataLayers[i]];
					for (let j = 0; j < layer.layers.length; j++) {
						const layerVisible = get(layer.visible);
						map.setLayoutProperty(layer.layers[j], "visibility", (visible && layerVisible) ? VisibilityState.VISIBLE : VisibilityState.NONE);
					}
				}
			}
		},
		updateFeatureCollection: () => {
			const featureCollection = GeoHelper.emptyGeoJson();
			const marmans = get(MARMANsStore.results.marmans);
			for (let i = 0; i < marmans.length; i++) {
				if (get(marmans[i].visible) &&
					get(marmans[i].loadState) === LoadState.LOADED) {
					featureCollection.features.push(marmans[i].asFeature());
				}
			}
			const map = MapStore.helpers.getMap();
			if (map) {
				const source = map.getSource("esri_marman");
				if (source) {
					source.setData(featureCollection);
				}
			}
		},
		loadSingle: (marmanModelObject) => {
			marmanModelObject.loadState.set(LoadState.LOADING);
			MARMANsStore.meta.lastUpdated.set(Date.now());

			// const layerType = marmanModelObject.type.toLowerCase();
			const layer = MARMANsStore.meta.esri.objects.layers.marman; // [layerType];
			const Query = ESRIClassStore.classes.Query.classPrototype;
			const SpatialReference = ESRIClassStore.classes.SpatialReference.classPrototype;

			const query = new Query();
			query.returnGeometry = true;
			query.outFields = ["FID"];
			query.geometryPrecision = 3;
			query.where = "FID = '" + marmanModelObject.esriId + "'";
			query.outSpatialReference = SpatialReference.WGS84;

			Promise.all([
				layer.queryFeatures(query)
			]).then((responses) => {
				const feature = arcgisToGeoJSON(responses[0].features[0]);
				const newFeature = feature; // GeoHelper.toWGS84(layer, feature);
				marmanModelObject.data.geometry = newFeature.geometry;
				marmanModelObject.loadState.set(LoadState.LOADED);

				MARMANsStore.actions.updateFeatureCollection();
				MARMANsStore.meta.lastUpdated.set(Date.now());
			});
		}
	},
	helpers: {
		// TODO: consider moving to a map helper.
		_addDataLayer: (name, type, paint, featureCollection, addToArray = null) => {
			if (addToArray == null) {
				addToArray = MARMANsStore.meta.layers;
			}
			const map = MapStore.helpers.getMap();
			map.addSource(name, {
				type: "geojson",
				data: featureCollection
			});
			map.addLayer(
				{
					id: name,
					type: type,
					source: name,
					paint: paint
				},
				"waterway-label" // MapLayer.VESSELS_NEARBY_LINES
			);
			addToArray.push(name);
		}
	}
};

export default MARMANsStore;
